import React from 'react';
import { Path, SVG } from 'web-common/src/shared/design-system/Utilities';

interface ProfileProps extends React.SVGProps<SVGSVGElement> {
  outline?: boolean;
}

export const Profile: React.FC<ProfileProps> = ({ outline = false, ...props }) => {
  if (outline) {
    return <ProfileOutline {...props} />;
  }

  return (
    <SVG width='24' height='24' viewBox='0 0 24 24' {...props}>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12Zm10-6c-1.94 0-3.5 1.56-3.5 3.5S10.06 13 12 13s3.5-1.56 3.5-3.5S13.94 6 12 6ZM5.513 16.683C6.553 15.403 9.066 14.5 12 14.5s5.446.902 6.487 2.183A7.99 7.99 0 0 1 12 20a7.99 7.99 0 0 1-6.487-3.317Z'
      />
    </SVG>
  );
};

export const ProfileOutline: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <SVG width='24' height='24' viewBox='0 0 24 24' {...props}>
    <Path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM18.3601 16.8302C16.9301 15.0902 13.4601 14.5002 12.0001 14.5002C10.5401 14.5002 7.07006 15.0902 5.64006 16.8302C4.62006 15.4902 4.00006 13.8202 4.00006 12.0002C4.00006 7.59023 7.59006 4.00023 12.0001 4.00023C16.4101 4.00023 20.0001 7.59023 20.0001 12.0002C20.0001 13.8202 19.3801 15.4902 18.3601 16.8302ZM8.50006 9.5002C8.50006 7.5602 10.0601 6.0002 12.0001 6.0002C13.9401 6.0002 15.5001 7.5602 15.5001 9.5002C15.5001 11.4402 13.9401 13.0002 12.0001 13.0002C10.0601 13.0002 8.50006 11.4402 8.50006 9.5002Z'
    />
  </SVG>
);
